/** Line icons used across the signed-in app (inline SVG, currentColor). */

/* --- Icons ------------------------------------------------------------------- */

const line = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.7,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export const Icon = {
  Plus: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" {...line} aria-hidden>
      <circle cx="12" cy="12" r="9" /><path d="M12 8v8M8 12h8" />
    </svg>
  ),
  Box: () => (
    <svg width="26" height="26" viewBox="0 0 24 24" {...line} aria-hidden>
      <path d="M3.5 8.5 12 4.5l8.5 4v7L12 19.5l-8.5-4z" /><path d="M3.5 8.5 12 12.5l8.5-4M12 12.5v7" />
      <path d="M15.5 14.3h1.5" />
    </svg>
  ),
  Wave: ({ size = 26 }: { size?: number }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="3.4"
         strokeLinecap="round" aria-hidden>
      <path d="M6 20v8M14 14v20M24 6v36M34 14v20M42 20v8" />
    </svg>
  ),
  Gear: ({ size = 26 }: { size?: number }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" {...line} aria-hidden>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1Z" />
    </svg>
  ),
  Book: ({ size = 26 }: { size?: number }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" {...line} aria-hidden>
      <path d="M12 6.5C10.5 5.3 8.3 4.7 4 4.8v13c4.3-.1 6.5.5 8 1.7 1.5-1.2 3.7-1.8 8-1.7v-13c-4.3-.1-6.5.5-8 1.7Z" />
      <path d="M12 6.5v13" />
    </svg>
  ),
  Cart: () => (
    <svg width="26" height="26" viewBox="0 0 24 24" {...line} aria-hidden>
      <path d="M3 4h2.2l2.1 10.2a1.5 1.5 0 0 0 1.5 1.2h8.4a1.5 1.5 0 0 0 1.5-1.2L20 7.5H6" />
      <circle cx="9.5" cy="19.5" r="1.3" /><circle cx="17" cy="19.5" r="1.3" />
    </svg>
  ),
  Wifi: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" {...line} aria-hidden>
      <path d="M2.5 9a14 14 0 0 1 19 0M5.5 12.5a9.5 9.5 0 0 1 13 0M8.6 15.8a5 5 0 0 1 6.8 0" />
      <circle cx="12" cy="19" r="1" fill="currentColor" />
    </svg>
  ),
  Storage: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" {...line} aria-hidden>
      <ellipse cx="12" cy="6" rx="7.5" ry="2.8" />
      <path d="M4.5 6v12c0 1.5 3.4 2.8 7.5 2.8s7.5-1.3 7.5-2.8V6M4.5 12c0 1.5 3.4 2.8 7.5 2.8s7.5-1.3 7.5-2.8" />
    </svg>
  ),
  Info: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" {...line} aria-hidden>
      <circle cx="12" cy="12" r="9" /><path d="M12 11v5.5" /><circle cx="12" cy="7.8" r="0.6" fill="currentColor" />
    </svg>
  ),
  Activity: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" {...line} aria-hidden>
      <rect x="3" y="6" width="18" height="14" rx="3" /><circle cx="12" cy="13" r="3.5" /><path d="M8.5 6l1.5-2.5h4L15.5 6" />
    </svg>
  ),
  Chevron: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" {...line} strokeWidth={2} aria-hidden>
      <path d="m9 6 6 6-6 6" />
    </svg>
  ),
  ArrowLeft: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" {...line} strokeWidth={2} aria-hidden>
      <path d="M19 12H5M11 6l-6 6 6 6" />
    </svg>
  ),
  Pencil: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" {...line} aria-hidden>
      <path d="M4 20h4L19 9a2.8 2.8 0 0 0-4-4L4 16z" /><path d="m13.5 6.5 4 4" />
    </svg>
  ),
  Copy: () => (
    <svg width="17" height="17" viewBox="0 0 24 24" {...line} aria-hidden>
      <rect x="8" y="8" width="12" height="12" rx="2" /><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" />
    </svg>
  ),
  Check: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" {...line} strokeWidth={2.2} aria-hidden>
      <path d="m5 12.5 4.5 4.5L19 7.5" />
    </svg>
  ),
  Restart: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" {...line} aria-hidden>
      <path d="M20 12a8 8 0 1 1-2.3-5.7M20 4v5h-5" />
    </svg>
  ),
  Trash: () => (
    <svg width="19" height="19" viewBox="0 0 24 24" {...line} aria-hidden>
      <path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" />
    </svg>
  ),
  Pin: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" {...line} aria-hidden>
      <path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11Z" /><circle cx="12" cy="10" r="2.4" />
    </svg>
  ),
  Clock: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" {...line} aria-hidden>
      <circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" />
    </svg>
  ),
  Link: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" {...line} aria-hidden>
      <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />
    </svg>
  ),
  Download: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" {...line} aria-hidden>
      <path d="M12 4v11M7 10l5 5 5-5M5 20h14" />
    </svg>
  ),
  Sliders: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" {...line} aria-hidden>
      <path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M20 18h0" /><circle cx="16" cy="6" r="2" /><circle cx="10" cy="12" r="2" /><circle cx="18" cy="18" r="2" />
    </svg>
  ),
  Mic: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" {...line} aria-hidden>
      <rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21" />
    </svg>
  ),
};
